<template>
  <div class="body">
    <div id="bgImage" class="bg-image"></div>
    <div class="login" style="position:relative;">
      <h2>管 理 员 登 录</h2>
      <div class="login_box">
        <input v-model="user.account" autocomplete="off" required/><label>账号</label>
      </div>
      <div class="login_box">
        <input v-model="user.password" autocomplete="off" type="password" v-on:keyup.enter="submit" required/><label>密码</label>
      </div>

      <div id="code"
           style="position: absolute;top: 27px;background-color: #fff;display: none">
        <slide-verify ref="slideblock" @success="onSuccess" @again="onAgain" @fulfilled="onFulfilled" @fail="onFail"
                      @refresh="onRefresh" @onClose="onClose" :slider-text="text" :imgs="imgs"
                      :accuracy="accuracy" :message="onMessage"></slide-verify>
        <!--     slide-verify的属性   :message="onMessage"-->
      </div>

      <a @click="submit" href="javascript:void(0)" style="margin-top: 10px">
        登录
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </a>
    </div>
  </div>
</template>

<script>
import img0 from '../../assets/img.jpg';
import img1 from '../../assets/img1.jpg';
import img2 from '../../assets/img2.jpg';
import img3 from '../../assets/img3.jpg';
import img4 from '../../assets/img4.jpg';
import img5 from '../../assets/img5.jpg';
import request from "../../utils/axiosUtils";
import base_url from "../../utils/Constants";

export default {
  name: "AdminLogin",
  components: {},
  data() {
    return {
      onMessage: null,
      text: '向右滑动完成拼图',
      user: {
        account: '',
        password: ''
      },
      imgs: [
        img0,
        img1,
        img2,
        img3,
        img4,
        img5,
      ],
      accuracy: 3, // 精确度小，可允许的误差范围小；为1时，则表示滑块要与凹槽完全重叠，才能验证成功。默认值为5
    }
  },
  methods: {
    onClose() {
      document.getElementById("code").style.display = "none"
    },
    submit() {
      let account = this.user.account.trim();
      let password = this.user.password.trim();
      if (account !== '' && password !== '') {
        this.onMessage = null
        document.getElementById("code").style.display = "flex"
      } else {
        this.$message.error('账号或者密码不能为哦空');
      }

    },
    onSuccess(times) {
      this.onMessage = `耗时${(times / 1000).toFixed(1)}s`
      setTimeout(() => {
        document.getElementById("code").style.display = "none";
        this.$refs.slideblock.reset();
        let account = this.user.account.trim();
        let password = this.user.password.trim();
        if (account !== '' && password !== '') {
          request({
            url: '/admin/login',
            methods: 'post',
            params: {
              adminLoginInfo: this.user,
              isCheck: false
            }
          }).then(response => {
            // console.log(response)
            let data = response.data.data;
            if (response.data.flag) {
              this.$message({
                type: "success",
                message: '登录成功'
              })
              window.sessionStorage.setItem("adminInfo", JSON.stringify(data))
              this.$router.push({
                name: "AdminIndex",
                path: '/admin/index',
              })
            } else {
              this.$message.error('账号或者密码错误');
            }
          })
        } else {
          this.$message.error('账号或者密码不能为哦空');
        }
      }, 1000)
    },
    onFail() {
      this.onMessage = "验证不通过"
      setTimeout(() => {
        this.onMessage = null
      }, 1000)
    },
    onRefresh() {
      // console.log('点击了刷新小图标');
      this.onMessage = null
    },
    onFulfilled() {
      // console.log('刷新成功啦！');
    },
    onAgain() {
      // console.log('检测到非人为操作的哦！');
      // 刷新
      this.handleClick();
    },
    handleClick() {
      this.$refs.slideblock.reset();
    },
  },
  mounted() {
    let bgImage = document.getElementById("bgImage");
    let random = parseInt(Math.random() * 27) + 1;
    bgImage.style.backgroundImage = "url(" + base_url + "/getStaticImage/bg" + random + ".png)"
  }
}
</script>

<style scoped>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

.bg-image {
  background-repeat: no-repeat;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-position: center center;
  background-size: cover;
  background-attachment: fixed;
}

.body {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.login {
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 400px;
  padding: 40px;
  background-color: rgba(255, 255, 255, 0.1);
  box-shadow: 0 15px 15px rgba(0, 0, 0, 0.4);
  border-radius: 15px;
}

.login h2 {
  color: #fff;
  margin-bottom: 30px;
}

.login .login_box {
  position: relative;
  width: 100%;
}

.login .login_box input {
  outline: none;
  border: none;
  width: 100%;
  padding: 10px 0;
  margin-bottom: 30px;
  color: #fff;
  font-size: 16px;
  border-bottom: 1px solid #fff;
  background-color: transparent;
}

.login .login_box label {
  position: absolute;
  top: 0;
  left: 0;
  padding: 10px 0;
  color: #fff;
  pointer-events: none;
  transition: all 0.5s;
}

.login .login_box input:focus + label,
.login .login_box input:valid + label {
  top: -20px;
  color: #03e9f4;
  font-size: 12px;
}

.login a {
  overflow: hidden;
  position: relative;
  padding: 10px 20px;
  color: #03e9f4;
  text-decoration: none;
  transition: all 0.5s;
}

.login a:hover {
  color: #fff;
  border-radius: 5px;
  background-color: rgba(3, 233, 244, 0.66);
  box-shadow: 0 0 5px rgba(3, 233, 244, 0.66), 0 0 25px rgba(3, 233, 244, 0.66), 0 0 50px rgba(3, 233, 244, 0.66), 0 0 100px rgba(3, 233, 244, 0.66);
}

.login a span {
  position: absolute;
}

.login a span:first-child {
  top: 0;
  left: -100%;
  width: 100%;
  height: 2px;
  background: linear-gradient(to right, transparent, #03e9f4);
  animation: move1 1s linear infinite;
}

.login a span:nth-child(2) {
  right: 0;
  top: -100%;
  width: 2px;
  height: 100%;
  background: linear-gradient(transparent, #03e9f4);
  animation: move2 1s linear 0.25s infinite;
}

.login a span:nth-child(3) {
  right: -100%;
  bottom: 0;
  width: 100%;
  height: 2px;
  background: linear-gradient(to left, transparent, #03e9f4);
  animation: move3 1s linear 0.5s infinite;
}

.login a span:last-child {
  left: 0;
  bottom: -100%;
  width: 2px;
  height: 100%;
  background: linear-gradient(#03e9f4, transparent);
  animation: move4 1s linear 0.75s infinite;
}

@keyframes move1 {
  0% {
    left: -100%;
  }
  50%,
  100% {
    left: 100%;
  }
}

@keyframes move2 {
  0% {
    top: -100%;
  }
  50%,
  100% {
    top: 100%;
  }
}

@keyframes move3 {
  0% {
    right: -100%;
  }
  50%,
  100% {
    right: 100%;
  }
}

@keyframes move4 {
  0% {
    bottom: -100%;
  }
  50%,
  100% {
    bottom: 100%;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/admin/AdminLogin.vue